const offersRes = {
  data: {
    categories: [
      {
        id: 25,
        name: 'Chase',
        rankings: [
          {
            rank: 1,
            product_id: '22126065',
            position_link: 'https://oc.brcclx.com/t/?lid=26673421&fid=25&pos=1'
          }
        ]
      },
      {
        id: 2809,
        name: 'Avant',
        rankings: [
          {
            rank: 1,
            product_id: '6353',
            position_link:
              'https://oc.brcclx.com/t/?lid=26673396&fid=2809&pos=1'
          }
        ]
      },
      {
        id: 2262,
        name: 'Credit One',
        rankings: [
          {
            rank: 1,
            product_id: '6853',
            position_link:
              'https://oc.brcclx.com/t/?lid=26673397&fid=2262&pos=1'
          }
        ]
      },
      {
        id: 14,
        name: 'Reward Credit Cards',
        rankings: [
          {
            rank: 1,
            product_id: '22126065',
            position_link: 'https://oc.brcclx.com/t/?lid=26673421&fid=14&pos=1'
          }
        ]
      },
      {
        id: 15,
        name: 'Cash Back Credit Cards',
        rankings: [
          {
            rank: 1,
            product_id: '6853',
            position_link: 'https://oc.brcclx.com/t/?lid=26673397&fid=15&pos=1'
          },
          {
            rank: 2,
            product_id: '229611108',
            position_link: 'https://oc.brcclx.com/t/?lid=26673404&fid=15&pos=2'
          }
        ]
      },
      {
        id: 1549,
        name: 'CardMatch Ordering',
        rankings: [
          {
            rank: 1,
            product_id: '6853',
            position_link: 'https://oc.brcclx.com/t/?lid=26673397&fid=15&pos=1'
          },
          {
            rank: 2,
            product_id: '229611108',
            position_link: 'https://oc.brcclx.com/t/?lid=26673404&fid=15&pos=2'
          },
          {
            rank: 3,
            product_id: '22126065',
            position_link: 'https://oc.brcclx.com/t/?lid=26673421&fid=14&pos=1'
          },
          {
            rank: 4,
            product_id: '6353',
            position_link:
              'https://oc.brcclx.com/t/?lid=26673396&fid=2809&pos=1'
          },
          {
            rank: 5,
            product_id: '7808',
            position_link:
              'https://oc.brcclx.com/t/?lid=26673396&fid=2809&pos=1'
          }
        ]
      },
      {
        id: 2474,
        name: 'Pre-Qualified',
        rankings: [
          {
            rank: 1,
            product_id: '6853',
            position_link: 'https://oc.brcclx.com/t/?lid=26673397&fid=15&pos=1'
          },
          {
            rank: 2,
            product_id: '7808',
            position_link: 'https://oc.brcclx.com/t/?lid=26673421&fid=14&pos=1'
          }
        ]
      },
      {
        id: 2662,
        name: 'Pre-Qualified No Disclosure',
        rankings: [
          {
            rank: 1,
            product_id: '229611108',
            position_link: 'https://oc.brcclx.com/t/?lid=26673404&fid=15&pos=2'
          },
          {
            rank: 2,
            product_id: '7808',
            position_link: 'https://oc.brcclx.com/t/?lid=26673421&fid=14&pos=1'
          }
        ]
      },
      {
        id: 2479,
        name: 'CardMatch - Special Offers',
        rankings: [
          {
            rank: 1,
            product_id: '22126065',
            position_link: 'https://oc.brcclx.com/t/?lid=26673421&fid=14&pos=1'
          },
          {
            rank: 2,
            product_id: '7808',
            position_link: 'https://oc.brcclx.com/t/?lid=26673421&fid=14&pos=1'
          }
        ]
      },
      {
        id: 2815,
        name: 'New Intro Offer',
        rankings: [
          {
            rank: 1,
            product_id: '7808',
            position_link: 'https://oc.brcclx.com/t?lid=26680064&fid=2815&pos=1'
          }
        ]
      }
    ],
    products: [
      {
        id: '7808',
        title: 'American Express&reg; Gold Card',
        description: '',
        sku: '',
        ptv: null,
        bullets:
          '<ul><li>Rose Gold is back. You can now choose between Gold or Rose Gold.</li><li>Earn 60,000 Membership Rewards&reg; points after you spend $4,000 on eligible purchases with your new Card within the first 6 months.</li><li>Earn 4X Membership Rewards&reg; Points on Restaurants worldwide, including takeout and delivery, plus, earn 4X points for Uber Eats purchases too.</li><li>Earn 4X Membership Rewards&reg; points at U.S. supermarkets (on up to $25,000 per calendar year in purchases, then 1X).</li><li>$120 Uber Cash: Add your Gold Card to your Uber account and each month automatically get $10 in Uber Cash for Uber Eats orders or Uber rides in the U.S., totaling up to $120 per year.</li><li>$120 Dining Credit: Earn up to a total of $10 in statement credits monthly when you pay with the Gold Card at Grubhub, Seamless, The Cheesecake Factory, Ruth\'s Chris Steak House, Boxed, and participating Shake Shack locations. This can be an annual savings of up to $120. Enrollment required.</li><li>Earn 3X Membership Rewards® points on flights booked directly with airlines or on amextravel.com.</li><li>No Foreign Transaction Fees.</li><li>Annual Fee is $250.</li><li>Terms Apply.</li><li><a href="https://www.americanexpress.com/us/credit-cards/card-application/apply/prospect/terms/gold-card/26129-10-0/?print#terms-details" target="blank">See Rates &amp; Fees</a></li></ul>',
        terms_and_conditions_url:
          'https://www.americanexpress.com/us/credit-cards/card-application/apply/prospect/terms/gold-card/26129-10-0/?print#terms-details',
        prequalified: false,
        issuer_id: {
          id: 'c81e728d9d4c2f636f067f89cc14862c',
          name: 'American Express'
        },
        image_path: '4e7d24d0-66ff-11eb-be9c-9790947db9db.png',
        link_url: 'https://oc.brcclx.com/t?lid=26680064',
        card_data: {
          purchases: [
            {
              intro_apr: {
                display: 'N/A',
                value: 999
              }
            },
            {
              regular_apr: {
                display: 'See Pay Over Time APR',
                value: 999
              }
            }
          ],
          balance_transfers: [
            {
              intro_apr: {
                display: 'N/A',
                value: 0
              }
            }
          ],
          fees: [
            {
              annual: {
                display: '$250 ',
                value: 250
              }
            }
          ]
        }
      },
      {
        id: '22126065',
        title: 'Chase Sapphire Preferred&#174; Card',
        description: '',
        sku: '22126065 ',
        ptv: null,
        bullets:
          "<ul><li>Earn 60,000 bonus points after you spend $4,000 on purchases in the first 3 months from account opening. That's $750 toward travel when you redeem through Chase Ultimate Rewards&reg;</li><li>2X points on travel and dining at restaurants worldwide & 1 point per dollar spent on all other purchases.</li><li>Get 25% more value when you redeem for airfare, hotels, car rentals and cruises through Chase Ultimate Rewards. For example, 60,000 points are worth $750 toward travel</li><li>Get unlimited deliveries with a $0 delivery fee and reduced service fees on orders over $12 for a minimum of one year on qualifying food purchases with DashPass, DoorDash's subscription service. Activate by 12/31/21.</li><li>Earn 5X points on Lyft rides through March 2022. That’s 3X points in addition to the 2X points you already earn on travel.</li></ul>",
        terms_and_conditions_url: null,
        prequalified: false,
        issuer_id: {
          id: 5,
          name: 'Chase'
        },
        image_path: '0a3cc800-4a52-11e9-a27b-d7eb75c86209.png',
        link_url: 'https://oc.brcclx.com/t/?lid=26673421',
        card_data: {
          purchases: [
            {
              intro_apr: {
                display: 'N/A',
                value: 999
              }
            },
            {
              regular_apr: {
                display: '15.99%-22.99% Variable',
                value: 15.99
              }
            }
          ],
          balance_transfers: [
            {
              intro_apr: {
                display: 'N/A',
                value: 0
              }
            }
          ],
          fees: [
            {
              annual: {
                display: '$95',
                value: 95
              }
            }
          ]
        }
      },
      {
        id: '229611108',
        title: 'Credit One Bank&#174; Visa&#174; Credit Card',
        description: '',
        sku: '229611108',
        ptv: null,
        bullets:
          "<ul><li>Find the card that's right for you without affecting your credit score.</li><li>Show off your personality by selecting from a variety of card designs, a fee may apply.</li><li>Get 1% cash back rewards on eligible purchases including gas, groceries, and services such as mobile phone, internet, cable and satellite TV, terms apply.</li><li>Set up custom email or text alerts so you'll always be aware of your payment due date, when your payment posts, or if your available credit runs low.</li><li>Don't get stuck with a payment date that doesn't work with your schedule. Credit One Bank allows you to choose your monthly payment due date. Terms apply.</li><li>Take advantage of free online access to your Experian credit score and credit report summary so you can track the key factors impacting your credit health. Terms apply.</li><li>Credit One Bank evaluates every account for credit line increase opportunities. We'll let you know as soon as you're eligible for a higher credit line.</li><li>Know you're protected from unauthorized charges with Zero Fraud Liability&mdash;included with every Credit One Bank account.</li><li><a href=\"https://www.creditonebank.com/pre-qualification/terms/all-terms\" target=\"blank\">See Rates &amp; Fees</a></li></ul>",
        terms_and_conditions_url: null,
        prequalified: false,
        issuer_id: {
          id: 132,
          name: 'Credit One Bank'
        },
        image_path: '42f99990-3c6c-11ea-9da1-ddf0e75bcd2c.png',
        link_url: 'https://oc.brcclx.com/t/?lid=26673404',
        card_data: {
          purchases: [
            {
              intro_apr: {
                display: 'N/A',
                value: 999
              }
            },
            {
              regular_apr: {
                display: '17.99% to 23.99% Variable',
                value: 17.99
              }
            }
          ],
          balance_transfers: [
            {
              intro_apr: {
                display: 'N/A',
                value: 0
              }
            }
          ],
          fees: [
            {
              annual: {
                display: '$0 - $99',
                value: 99
              }
            }
          ]
        }
      },
      {
        id: '6353',
        title: 'Avant Credit Card',
        description: '',
        sku: '',
        ptv: null,
        bullets:
          '<ul><li>No deposit required</li><li>Reports to all three major credit bureaus</li><li>No penalty APR</li><li>No hidden fees</li><li>We may periodically review your account for credit line increases</li><li>Fast and easy application process</li><li>Help strengthen your credit history with responsible use</li><li>Zero fraud liability for unauthorized charges</li><li>Conveniently pay your card through our online portal, 24/7</li><li>Get Mastercard&reg; ID Theft Protection by Mastercard</li><li>Disclosure: If you are charged interest, the charge will be no less than $1.00. Cash Advance Fee 3%, Min: $10</li><li>Avant branded credit products are issued by WebBank, member FDIC</li></ul>',
        terms_and_conditions_url: null,
        prequalified: false,
        issuer_id: {
          id: 255,
          name: 'Avant'
        },
        image_path: '5eedc5b0-8dec-11e9-8722-693ca85294bf.png',
        link_url: 'https://oc.brcclx.com/t/?lid=26673396',
        card_data: {
          purchases: [
            {
              intro_apr: {
                display: 'N/A',
                value: 999
              }
            },
            {
              regular_apr: {
                display: '25.99% (variable)',
                value: 25.99
              }
            }
          ],
          balance_transfers: [
            {
              intro_apr: {
                display: 'N/A',
                value: 0
              }
            }
          ],
          fees: [
            {
              annual: {
                display: '$39',
                value: 39
              }
            }
          ]
        }
      },
      {
        id: '6853',
        title: 'Credit One Bank American Express&reg; Card',
        description: '',
        sku: '',
        ptv: null,
        bullets:
          '<ul><li>Earn unlimited 1% cash back rewards on all purchases, terms apply.</li><li>$0 Fraud Liability ensures you won’t be responsible for unauthorized charges</li><li>Retail Protection covers you if an eligible item is accidentally damaged or stolen, terms apply</li><li>Get deals on shopping, dining, travel, and entertainment through Amex Offers</li><li>Enjoy exclusive access to pre-sale tickets for some of the hottest nationwide concerts and events</li><li>Know you’re covered when the unexpected happens while traveling with Travel Accident Insurance, terms apply</li><li>If you are a Covered Borrower under the Military Lending Act, you may get a different offer</li><li><a href="https://www.creditonebank.com/content/experience-fragments/terms/7i?cpr=23.99&ccr=23.99&pc=WX27"> See Rates &amp; Fees</a></li></ul>',
        terms_and_conditions_url: null,
        prequalified: false,
        issuer_id: {
          id: 132,
          name: 'Credit One Bank'
        },
        image_path: '4dbae080-1d0b-11ea-8a9e-877b2e714ca4.png',
        link_url: 'https://oc.brcclx.com/t/?lid=26673397',
        card_data: {
          purchases: [
            {
              intro_apr: {
                display: 'N/A',
                value: 999
              }
            },
            {
              regular_apr: {
                display: '23.99% Variable',
                value: 23.99
              }
            }
          ],
          balance_transfers: [
            {
              intro_apr: {
                display: 'N/A',
                value: 0
              }
            }
          ],
          fees: [
            {
              annual: {
                display: '$39',
                value: 39
              }
            }
          ]
        }
      }
    ]
  }
}

const complianceRes = {
  data: {
    categories: [
      {
        id: 25,
        name: 'Chase',
        rankings: [
          {
            rank: 1,
            product_id: '22126065',
            position_link: 'https://oc.brcclx.com/t/?lid=26673421&fid=25&pos=1'
          }
        ]
      },
      {
        id: 2809,
        name: 'Avant',
        rankings: [
          {
            rank: 1,
            product_id: '6353',
            position_link:
              'https://oc.brcclx.com/t/?lid=26673396&fid=2809&pos=1'
          }
        ]
      },
      {
        id: 2262,
        name: 'Credit One',
        rankings: [
          {
            rank: 1,
            product_id: '6853',
            position_link:
              'https://oc.brcclx.com/t/?lid=26673397&fid=2262&pos=1'
          }
        ]
      },
      {
        id: 14,
        name: 'Reward Credit Cards',
        rankings: [
          {
            rank: 1,
            product_id: '22126065',
            position_link: 'https://oc.brcclx.com/t/?lid=26673421&fid=14&pos=1'
          }
        ]
      },
      {
        id: 15,
        name: 'Cash Back Credit Cards',
        rankings: [
          {
            rank: 1,
            product_id: '6853',
            position_link: 'https://oc.brcclx.com/t/?lid=26673397&fid=15&pos=1'
          },
          {
            rank: 2,
            product_id: '229611108',
            position_link: 'https://oc.brcclx.com/t/?lid=26673404&fid=15&pos=2'
          }
        ]
      },
      {
        id: 1549,
        name: 'CardMatch Ordering',
        rankings: [
          {
            rank: 1,
            product_id: '6853',
            position_link: 'https://oc.brcclx.com/t/?lid=26673397&fid=15&pos=1'
          },
          {
            rank: 2,
            product_id: '229611108',
            position_link: 'https://oc.brcclx.com/t/?lid=26673404&fid=15&pos=2'
          },
          {
            rank: 3,
            product_id: '22126065',
            position_link: 'https://oc.brcclx.com/t/?lid=26673421&fid=14&pos=1'
          },
          {
            rank: 4,
            product_id: '6353',
            position_link:
              'https://oc.brcclx.com/t/?lid=26673396&fid=2809&pos=1'
          }
        ]
      },
      {
        id: 2474,
        name: 'Pre-Qualified',
        rankings: [
          {
            rank: 1,
            product_id: '6853',
            position_link: 'https://oc.brcclx.com/t/?lid=26673397&fid=15&pos=1'
          }
        ]
      },
      {
        id: 2662,
        name: 'Pre-Qualified No Disclosure',
        rankings: [
          {
            rank: 1,
            product_id: '229611108',
            position_link: 'https://oc.brcclx.com/t/?lid=26673404&fid=15&pos=2'
          }
        ]
      },
      {
        id: 2479,
        name: 'CardMatch - Special Offers',
        rankings: [
          {
            rank: 1,
            product_id: '22126065',
            position_link: 'https://oc.brcclx.com/t/?lid=26673421&fid=14&pos=1'
          }
        ]
      }
    ],
    products: [
      {
        id: '22126065',
        title: 'Chase Sapphire Preferred&#174; Card',
        description: '',
        sku: '22126065 ',
        ptv: null,
        bullets:
          "<ul><li>Earn 60,000 bonus points after you spend $4,000 on purchases in the first 3 months from account opening. That's $750 toward travel when you redeem through Chase Ultimate Rewards&reg;</li><li>2X points on travel and dining at restaurants worldwide & 1 point per dollar spent on all other purchases.</li><li>Get 25% more value when you redeem for airfare, hotels, car rentals and cruises through Chase Ultimate Rewards. For example, 60,000 points are worth $750 toward travel</li><li>Get unlimited deliveries with a $0 delivery fee and reduced service fees on orders over $12 for a minimum of one year on qualifying food purchases with DashPass, DoorDash's subscription service. Activate by 12/31/21.</li><li>Earn 5X points on Lyft rides through March 2022. That’s 3X points in addition to the 2X points you already earn on travel.</li></ul>",
        terms_and_conditions_url: null,
        prequalified: false,
        issuer_id: {
          id: 5,
          name: 'Chase'
        },
        image_path: '0a3cc800-4a52-11e9-a27b-d7eb75c86209.png',
        link_url: 'https://oc.brcclx.com/t/?lid=26673421',
        card_data: {
          purchases: [
            {
              intro_apr: {
                display: 'N/A',
                value: 999
              }
            },
            {
              regular_apr: {
                display: '15.99%-22.99% Variable',
                value: 15.99
              }
            }
          ],
          balance_transfers: [
            {
              intro_apr: {
                display: 'N/A',
                value: 0
              }
            }
          ],
          fees: [
            {
              annual: {
                display: '$95',
                value: 95
              }
            }
          ]
        }
      },
      {
        id: '229611108',
        title: 'Credit One Bank&#174; Visa&#174; Credit Card',
        description: '',
        sku: '229611108',
        ptv: null,
        bullets:
          "<ul><li>Find the card that's right for you without affecting your credit score.</li><li>Show off your personality by selecting from a variety of card designs, a fee may apply.</li><li>Get 1% cash back rewards on eligible purchases including gas, groceries, and services such as mobile phone, internet, cable and satellite TV, terms apply.</li><li>Set up custom email or text alerts so you'll always be aware of your payment due date, when your payment posts, or if your available credit runs low.</li><li>Don't get stuck with a payment date that doesn't work with your schedule. Credit One Bank allows you to choose your monthly payment due date. Terms apply.</li><li>Take advantage of free online access to your Experian credit score and credit report summary so you can track the key factors impacting your credit health. Terms apply.</li><li>Credit One Bank evaluates every account for credit line increase opportunities. We'll let you know as soon as you're eligible for a higher credit line.</li><li>Know you're protected from unauthorized charges with Zero Fraud Liability&mdash;included with every Credit One Bank account.</li><li><a href=\"https://www.creditonebank.com/pre-qualification/terms/all-terms\" target=\"blank\">See Rates &amp; Fees</a></li></ul>",
        terms_and_conditions_url: null,
        prequalified: false,
        issuer_id: {
          id: 132,
          name: 'Credit One Bank'
        },
        image_path: '42f99990-3c6c-11ea-9da1-ddf0e75bcd2c.png',
        link_url: 'https://oc.brcclx.com/t/?lid=26673404',
        card_data: {
          purchases: [
            {
              intro_apr: {
                display: 'N/A',
                value: 999
              }
            },
            {
              regular_apr: {
                display: '17.99% to 23.99% Variable',
                value: 17.99
              }
            }
          ],
          balance_transfers: [
            {
              intro_apr: {
                display: 'N/A',
                value: 0
              }
            }
          ],
          fees: [
            {
              annual: {
                display: '$0 - $99',
                value: 99
              }
            }
          ]
        }
      },
      {
        id: '6353',
        title: 'Avant Credit Card',
        description: '',
        sku: '',
        ptv: null,
        bullets:
          '<ul><li>No deposit required</li><li>Reports to all three major credit bureaus</li><li>No penalty APR</li><li>No hidden fees</li><li>We may periodically review your account for credit line increases</li><li>Fast and easy application process</li><li>Help strengthen your credit history with responsible use</li><li>Zero fraud liability for unauthorized charges</li><li>Conveniently pay your card through our online portal, 24/7</li><li>Get Mastercard&reg; ID Theft Protection by Mastercard</li><li>Disclosure: If you are charged interest, the charge will be no less than $1.00. Cash Advance Fee 3%, Min: $10</li><li>Avant branded credit products are issued by WebBank, member FDIC</li></ul>',
        terms_and_conditions_url: null,
        prequalified: false,
        issuer_id: {
          id: 255,
          name: 'Avant'
        },
        image_path: '5eedc5b0-8dec-11e9-8722-693ca85294bf.png',
        link_url: 'https://oc.brcclx.com/t/?lid=26673396',
        card_data: {
          purchases: [
            {
              intro_apr: {
                display: 'N/A',
                value: 999
              }
            },
            {
              regular_apr: {
                display: '25.99% (variable)',
                value: 25.99
              }
            }
          ],
          balance_transfers: [
            {
              intro_apr: {
                display: 'N/A',
                value: 0
              }
            }
          ],
          fees: [
            {
              annual: {
                display: '$39',
                value: 39
              }
            }
          ]
        }
      },
      {
        id: '6853',
        title: 'Credit One Bank American Express&reg; Card',
        description: '',
        sku: '',
        ptv: null,
        bullets:
          '<ul><li>Earn unlimited 1% cash back rewards on all purchases, terms apply.</li><li>$0 Fraud Liability ensures you won’t be responsible for unauthorized charges</li><li>Retail Protection covers you if an eligible item is accidentally damaged or stolen, terms apply</li><li>Get deals on shopping, dining, travel, and entertainment through Amex Offers</li><li>Enjoy exclusive access to pre-sale tickets for some of the hottest nationwide concerts and events</li><li>Know you’re covered when the unexpected happens while traveling with Travel Accident Insurance, terms apply</li><li>If you are a Covered Borrower under the Military Lending Act, you may get a different offer</li><li><a href="https://www.creditonebank.com/content/experience-fragments/terms/7i?cpr=23.99&ccr=23.99&pc=WX27"> See Rates &amp; Fees</a></li></ul>',
        terms_and_conditions_url: null,
        prequalified: false,
        issuer_id: {
          id: 132,
          name: 'Credit One Bank'
        },
        image_path: '4dbae080-1d0b-11ea-8a9e-877b2e714ca4.png',
        link_url: 'https://oc.brcclx.com/t/?lid=26673397',
        card_data: {
          purchases: [
            {
              intro_apr: {
                display: 'N/A',
                value: 999
              }
            },
            {
              regular_apr: {
                display: '23.99% Variable',
                value: 23.99
              }
            }
          ],
          balance_transfers: [
            {
              intro_apr: {
                display: 'N/A',
                value: 0
              }
            }
          ],
          fees: [
            {
              annual: {
                display: '$39',
                value: 39
              }
            }
          ]
        }
      }
    ]
  }
}

const getUserDataRes = {
  city: 'Austin',
  emailAddress: 'rmclaughlin@redventures.com',
  firstName: 'Robert',
  lastName: 'McLaughlin',
  state: 'TX',
  streetAddress: '4444 South Congress Ave.',
  zipCode: '78704',
  ssn: '4444'
}

const createUserRes = {
  accessToken:
    'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0ZW5hbnRfaWQiOiI1ZGNkMDBiNi04NmU0LTExZTgtYWRjMC1mYTdhZTAxYmJlYmMiLCJ0ZW5hbnRfbmFtZSI6ImJhbmtyYXRlIiwidXNlcl9uYW1lIjoiYmVhc3Rtb2RlYnIrMDEyMTFAZ21haWwuY29tIiwiYXV0aG9yaXRpZXMiOlsiUk9MRV9DVVNUT01FUiJdLCJjbGllbnRfaWQiOiJiYW5rcmF0ZS1wZXJzb25hbC1sb2FucyIsImF1ZCI6WyJydmxhLXNlcnZpY2VzIl0sImxlZ2FjeV9hcGlfY2xpZW50X2lkIjpudWxsLCJ1c2VyX2lkIjoiOWE2OWU2ZmMtZTUyMS00YmEzLTg4M2QtMWUzM2Y5ZTA5ZTQ0Iiwic2NvcGUiOlsib2F1dGg6cmVhZCIsImlkZW50aXR5OndyaXRlIiwicHJlYXV0aDpyZWFkIiwic3ViOndyaXRlIiwibWFya2V0aW5nOndyaXRlIl0sImV4cCI6MTU5NjAwMDQ4MywiY3VzdG9tZXJfaWQiOiI5YTY5ZTZmYy1lNTIxLTRiYTMtODgzZC0xZTMzZjllMDllNDQiLCJiZWRyb2NrX2lkIjoiOWE2OWU2ZmMtZTUyMS00YmEzLTg4M2QtMWUzM2Y5ZTA5ZTQ0IiwianRpIjoiODYzZTY1NTctYzQ2Ny00YTc3LWJhMDYtMmRhOWRiZGFjMTg5In0.BnenjOOw2HUkGvCFyQmBjCA3uSLM0156qN0ZSFkI-1yyFqTI-JhWG79z-iL7BLq_vNviQaAIZjjLpY76vKSphi8FSqkAIjIS3vdoSAudkhy-WnDGelNnKSwKESk4m_TkTsbB0bthMZ9iv5dQbfjHPerJFcvQOCrqIDiEJHJ-SQNWsu_o2JOyTWvK_gAmE2Unl2WqFHZaR7irjESB6D8zO2scWtC64Of0L3QYMXPiOw7LcwYGBuCwP-5qzwKI0Gm0gX60vN7e1jO_DqkH8L5h2_ucWqfk15F7C0FZ4AqGIWIdJsjN6m-jdAroQJPWZODRVM5T2HrxHkQQGsnsZvNdAw',
  customerId: '9a69e6fc-e521-4ba3-883d-1e33f9e09e44'
}

const createPasswordlessUserRes = {
  customerId: 'fb51b252-72e8-403c-815b-1076b03c84f2'
}

const updateUserRes = {
  data: {
    updateProfile: true
  }
}

const updateUserProfileRes = {
  data: {
    id: '4e9617b0-b0cf-4c2f-a682-541ae1c112f6',
    personal: {
      first_name: 'Person',
      last_name: 'Human',
      address_street: null,
      address_city: null,
      address_state: null,
      address_zip: null,
      phone: null,
      email: 'user@bankrate.com',
      employer: null,
      avatar: null,
      date_of_birth: null,
      employment_status: null,
      total_investable_assets: null,
      total_debt: null,
      total_income: null,
      welcome_views: true,
      last_nps_survey_date: null
    },
    article_ids: ['some-wordpress-id-1', 'some-wordpress-id-1'],
    goal_names: ['SAVING_MONEY'],
    product_interest_names: ['HOME_EQUITY', 'CERTIFICATE_OF_DEPOSIT'],
    saved_questions: [
      {
        question_name: 'BUY_HOME_FIRST_TIME',
        answer_name: 'NO'
      }
    ],
    calculators: [
      {
        identifier: 'amortization-calculator',
        title: 'Amortization Calculator Result',
        results: [
          {
            identifier: 'monthly-payment',
            label: 'Monthly Payment',
            values: ['2000.25']
          }
        ],
        input_fields: [
          {
            identifier: 'interest-rate',
            label: 'Interest Rate',
            values: ['3.5']
          },
          {
            identifier: 'loan-amount',
            label: 'Loan Amount',
            values: ['3.5']
          },
          {
            identifier: 'loan-term',
            label: 'Loan Term Months',
            values: ['60']
          }
        ]
      }
    ],
    rate_tables: [
      {
        identifier: '#certificate-of-deposit',
        title: 'Certificate of Deposit',
        input_fields: [
          {
            identifier: '#specific-terms',
            label: 'Specific Terms',
            values: ['6 Months', '5 Years']
          },
          {
            identifier: '#terms-range',
            label: 'Terms Range',
            values: ['1 Month', '2 Years']
          },
          {
            identifier: '#deposit-amount',
            label: 'Deposit Amount',
            values: ['25000']
          },
          {
            identifier: '#sort-by',
            label: 'Sort By',
            values: ['Default']
          },
          {
            identifier: '#zip-code',
            label: 'Zip Code',
            values: ['90012']
          },
          {
            identifier: '#deposit-type',
            label: 'Deposit Type',
            values: ['CD Rates']
          }
        ]
      }
    ],
    product_offers: [
      {
        type: 'MORTGAGE',
        created: '2019-10-11T19:17:18.551167-04:00',
        expiration: '2019-10-12T07:17:18.551167-04:00',
        details: '{"some": "url"}'
      },
      {
        type: 'PERSONAL_LOAN',
        created: '2019-10-11T19:17:18.551167-04:00',
        expiration: '2019-10-12T07:17:18.551167-04:00',
        details: ''
      }
    ]
  }
}

const resIndex = {
  offersRes,
  getUserDataRes,
  createUserRes,
  createPasswordlessUserRes,
  updateUserRes,
  complianceRes,
  updateUserProfileRes
}

// Send back promise resolving to mock data, for fake response to UI
const mockResponse = ({ type }) => {
  return new Promise((resolve, reject) => {
    try {
      setTimeout(() => {
        resolve(resIndex[`${type}Res`])
      }, 1000)
    } catch (error) {
      reject(error)
    }
  })
}

export default mockResponse
